/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface HttpError { 
    /**
     * The high-level, user-visible message explaining the cause of the error. Information carried in this field should be considered public in that it will go over the wire regardless of the value of error detail policy. As a result care should be taken not to disclose sensitive information about the server or the application.
     */
    message?: string | null;
    modelState?: HttpError | null;
    /**
     * A detailed description of the error intended for the developer to understand exactly what failed.
     */
    messageDetail?: string | null;
    /**
     * The message of the Exception if available.
     */
    exceptionMessage?: string | null;
    /**
     * The type of the Exception if available.
     */
    exceptionType?: string | null;
    /**
     * The stack trace information associated with this instance if available.
     */
    stackTrace?: string | null;
    innerException?: HttpError | null;
}

